import React from 'react';
import {firebase} from "../../../firebase/firebaseConfig";

//Material UI Imports
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import PropTypes from 'prop-types';

const headCells = [
  { id: 'authorName', numeric: false, label: 'Author' },
  { id: 'date', numeric: false, label: 'Date' },
  { id: 'summary', numeric: false, label: 'Summary' },
  { id: 'sectors', numeric: false, label: 'Industry' },
  { id: 'location', numeric: false, label: 'Location' },
  { id: 'upvotes', numeric: true, label: 'Upvotes' }
];

// ============== ACTUAL TABLE ================== //

//Returns just the table header
export default function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  
  /*You call this function. Tell it which property (column) needs to be sorted
  The function returns another function. Return function takes in event object 
  (ex. on click) and calls the onRequest Sort function. */
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
    firebase.analytics().logEvent('table_sort', {sortCol: property});
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell //Setting key, aligning cell, padding cell, and whether cell should show sort
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'} 
              onClick={createSortHandler(headCell.id)} //Event handler for sort request
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))} 
      </TableRow>
    </TableHead>
  ); //In the Table Sort Label, I assume any text will be converted to icons
}

//Used for checking right props are passed in. 
EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};